import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import SvgCameraFill from '@common/icon/SvgCameraFill';
import SvgRecommFill from '@common/icon/SvgRecommFill';
import type { GoodsHomeReviewItem } from './ReviewSectionServer';
const REVIEW_LABEL = {
  TRIAL: {
    text: '체험단 후기',
    Icon: SvgRecommFill,
    className: 'bg-O-25 text-O-500'
  },
  DONATION: {
    text: '포토리뷰',
    Icon: SvgCameraFill,
    className: 'bg-M-25 text-M-400'
  }
} as const;
export const getReviewLabelText = (orderType: GoodsHomeReviewItem['orderType']) => REVIEW_LABEL[orderType].text;
export const ReviewLabelBadge = t0 => {
  const $ = _c(6);
  const {
    orderType
  } = t0;
  const {
    text,
    Icon,
    className
  } = REVIEW_LABEL[orderType];
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon className="size-14" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1 || $[4] !== text) {
    t2 = <Badge dimensions="H20" className={className}>{t1}{text}</Badge>;
    $[2] = className;
    $[3] = t1;
    $[4] = text;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};